"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppMetadataManager = void 0;
const __1 = require("..");
const StorageManager_1 = require("./StorageManager");
class AppMetadataManager {
    constructor(storage) {
        this.storageManager = new StorageManager_1.StorageManager(storage, __1.StorageKey.APP_METADATA_LIST);
    }
    async getAppMetadataList() {
        return this.storageManager.getAll();
    }
    async getAppMetadata(beaconId) {
        return this.storageManager.getOne((appMetadata) => appMetadata.beaconId === beaconId);
    }
    async addAppMetadata(appMetadata) {
        return this.storageManager.addOne(appMetadata, (appMetadataElement) => appMetadataElement.beaconId === appMetadata.beaconId);
    }
    async removeAppMetadata(beaconId) {
        return this.storageManager.remove((appMetadata) => appMetadata.beaconId === beaconId);
    }
    async removeAppMetadatas(beaconIds) {
        return this.storageManager.remove((appMetadata) => beaconIds.includes(appMetadata.beaconId));
    }
    async removeAllAppMetadata() {
        return this.storageManager.removeAll();
    }
}
exports.AppMetadataManager = AppMetadataManager;
//# sourceMappingURL=AppMetadataManager.js.map